import { render, staticRenderFns } from "./NoticeBoardForm.vue?vue&type=template&id=273a556c&scoped=true"
import script from "./NoticeBoardForm.vue?vue&type=script&lang=js"
export * from "./NoticeBoardForm.vue?vue&type=script&lang=js"
import style0 from "./NoticeBoardForm.vue?vue&type=style&index=0&id=273a556c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a556c",
  null
  
)

export default component.exports